import { useEffect, useState } from 'react';
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import '../styles/ExportVote.css';
import '../styles/BaseForm.css';
import '../styles/canvas.css';
import fr from '../locales/fr';
import en from '../locales/en';

function ExportMot({ ws }) {
  const [mot, setInputMot] = useState('');
  const navigate = useNavigate();
  const browserLang = navigator.language || navigator.userLanguage;
  const language = browserLang.startsWith('fr') ? 'fr' : 'en';
  const translations = language === 'fr' ? fr : en;

  const location = useLocation();

  const allowed =
    location.state?.fromMediaSelect ||
    sessionStorage.getItem('canAccessExportMot');

  useEffect(() => {
    if (allowed) {
      sessionStorage.removeItem('canAccessExportMot');
    }
  }, [allowed]);

  if (!allowed) {
    return <Navigate to="/mediaSelect" replace />;
  }


  const handleInputChange = (e) => {
    setInputMot(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!mot) {
      return;
    }

    try {

      var unityID = localStorage.getItem('UNITY');
      var pseudo = localStorage.getItem('pseudo');
      var pseudoColor = localStorage.getItem('pseudoColor');

      ws.send(unityID + ":NPþ" + pseudo + "þ" + pseudoColor + "þWRDþ" + mot);
      sessionStorage.setItem('canAccessReady', 'true');
      navigate('/Ready', { state: { fromAuthorized: true } });


      setInputMot('');
    } catch (error) {
      console.error('Error sending data via WebSocket:', error);
    }
  };

  return (
    <div className="boxform">
      <h1 className="title">{translations.exportMot.title}</h1>
      <form onSubmit={handleSubmit} className="labelform">
        <label className="labelform"></label>
        <input
          type="text"
          value={mot}
          onChange={handleInputChange}
          className="champreponse"
          placeholder={translations.exportMot.placeholder}
        />
        <button type="submit" className="submit-button">{translations.exportMot.submit}</button>
      </form>
    </div>
  );
}

export default ExportMot;
